import type { RouteRecordRaw } from 'vue-router';

export const projectRoutes: Array<RouteRecordRaw> = [
  {
    path: '/project',
    name: 'project',
    redirect: '/project/list',
    component: () => import('pages/micros/project/project/McProject.vue'),
    meta: {
      title: 'Project Management Solution',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectList',
        component: () => import('pages/micros/project/project/ProjectList.vue'),
        meta: {
          title: 'Projects List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectDetail',
        component: () => import('pages/micros/project/project/ProjectDetail.vue'),
        meta: {
          title: 'Project Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectNew',
        component: () => import('pages/micros/project/project/ProjectNew.vue'),
        meta: {
          title: 'New Project',
          requiresAuth: true,
        },
      },
      {
        path: 'schedule',
        name: 'projectSchedule',
        component: () => import('pages/micros/project/project/ProjectSchedule.vue'),
        meta: {
          title: 'Project Schedule [Gant Chart]',
          requiresAuth: true,
        },
      },
      {
        path: 'timeline',
        name: 'projectTimeline',
        component: () => import('pages/micros/project/project/ProjectTimeline.vue'),
        meta: {
          title: 'Project Timeline',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/account',
    name: 'projectAccount',
    redirect: '/project/account/list',
    component: () => import('pages/micros/project/account/McAccount.vue'),
    meta: {
      title: 'Accounts - Cost & Income Centres',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectAccountList',
        component: () => import('pages/micros/project/account/AccountList.vue'),
        meta: {
          title: 'Accounts List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectAccountDetail',
        component: () => import('pages/micros/project/account/AccountDetail.vue'),
        meta: {
          title: 'Account Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectAccountNew',
        component: () => import('pages/micros/project/account/AccountNew.vue'),
        meta: {
          title: 'New Account',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/bank',
    name: 'projectBank',
    redirect: '/project/bank/list',
    component: () => import('pages/micros/project/bank/McBank.vue'),
    meta: {
      title: 'Banking Transactions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectBankList',
        component: () => import('pages/micros/project/bank/BankList.vue'),
        meta: {
          title: 'Bank Transactions List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectBankDetail',
        component: () => import('pages/micros/project/bank/BankDetail.vue'),
        meta: {
          title: 'Bank Transaction Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectBankNew',
        component: () => import('pages/micros/project/bank/BankNew.vue'),
        meta: {
          title: 'New Bank Transaction',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/budget',
    name: 'projectBudget',
    redirect: '/project/budget/list',
    component: () => import('pages/micros/project/budget/ProjectBudget.vue'),
    meta: {
      title: 'Budgets',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectBudgetList',
        component: () => import('pages/micros/project/budget/BudgetList.vue'),
        meta: {
          title: 'Budgets List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectBudgetDetail',
        component: () => import('pages/micros/project/budget/BudgetDetail.vue'),
        meta: {
          title: 'Budget Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectBudgetNew',
        component: () => import('pages/micros/project/budget/BudgetNew.vue'),
        meta: {
          title: 'New Budget',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/calendar',
    name: 'projectCalendar',
    redirect: '/project/calendar/list',
    component: () => import('pages/micros/project/calendar/ProjectCalendar.vue'),
    meta: {
      title: 'Calendars',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectCalendarList',
        component: () => import('pages/micros/project/calendar/CalendarList.vue'),
        meta: {
          title: 'Calendars List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectCalendarDetail',
        component: () => import('pages/micros/project/calendar/CalendarDetail.vue'),
        meta: {
          title: 'Calendar Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectCalendarNew',
        component: () => import('pages/micros/project/calendar/CalendarNew.vue'),
        meta: {
          title: 'New Calendar',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/estimate',
    name: 'projectEstimate',
    redirect: '/project/estimate/list',
    component: () => import('pages/micros/project/estimate/ProjectEstimate.vue'),
    meta: {
      title: 'Estimates',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectEstimateList',
        component: () => import('pages/micros/project/estimate/EstimateList.vue'),
        meta: {
          title: 'Estimates List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectEstimateDetail',
        component: () => import('pages/micros/project/estimate/EstimateDetail.vue'),
        meta: {
          title: 'Estimate Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectEstimateNew',
        component: () => import('pages/micros/project/estimate/EstimateNew.vue'),
        meta: {
          title: 'New Estimate',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/expense',
    name: 'projectExpense',
    redirect: '/project/expense/list',
    component: () => import('pages/micros/project/expense/McExpense.vue'),
    meta: {
      title: 'Expenses',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectExpenseList',
        component: () => import('pages/micros/project/expense/ExpenseList.vue'),
        meta: {
          title: 'Expenses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectExpenseDetail',
        component: () => import('pages/micros/project/expense/ExpenseDetail.vue'),
        meta: {
          title: 'Expense Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectExpenseNew',
        component: () => import('pages/micros/project/expense/ExpenseNew.vue'),
        meta: {
          title: 'New Expense',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/income',
    name: 'projectIncome',
    redirect: '/project/income/list',
    component: () => import('pages/micros/project/income/McIncome.vue'),
    meta: {
      title: 'Incomes',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectIncomeList',
        component: () => import('pages/micros/project/income/IncomeList.vue'),
        meta: {
          title: 'Incomes List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectIncomeDetail',
        component: () => import('pages/micros/project/income/IncomeDetail.vue'),
        meta: {
          title: 'Income Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectIncomeNew',
        component: () => import('pages/micros/project/income/IncomeNew.vue'),
        meta: {
          title: 'New Income',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/issue',
    name: 'projectIssue',
    redirect: '/project/issue/list',
    component: () => import('pages/micros/project/issue/McIssue.vue'),
    meta: {
      title: 'Issues',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectIssueList',
        component: () => import('pages/micros/project/issue/IssueList.vue'),
        meta: {
          title: 'Issues List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectIssueDetail',
        component: () => import('pages/micros/project/issue/IssueDetail.vue'),
        meta: {
          title: 'Issue Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectIssueNew',
        component: () => import('pages/micros/project/issue/IssueNew.vue'),
        meta: {
          title: 'New Issue',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/plan',
    name: 'projectPlan',
    redirect: '/project/plan/list',
    component: () => import('pages/micros/project/plan/McPlan.vue'),
    meta: {
      title: 'Plans',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectPlanList',
        component: () => import('pages/micros/project/plan/PlanList.vue'),
        meta: {
          title: 'Plans List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectPlanDetail',
        component: () => import('pages/micros/project/plan/PlanDetail.vue'),
        meta: {
          title: 'Plan Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectPlanNew',
        component: () => import('pages/micros/project/plan/PlanNew.vue'),
        meta: {
          title: 'New Plan',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/document',
    name: 'projectDocument',
    redirect: '/project/document/list',
    component: () => import('pages/micros/project/document/ProjectDocument.vue'),
    meta: {
      title: 'Project Documents',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectDocumentList',
        component: () => import('pages/micros/project/document/DocumentList.vue'),
        meta: {
          title: 'Project Documents List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectDocumentDetail',
        component: () => import('pages/micros/project/document/DocumentDetail.vue'),
        meta: {
          title: 'Project Document Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectDocumentNew',
        component: () => import('pages/micros/project/document/DocumentNew.vue'),
        meta: {
          title: 'New Project Document',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/resource',
    name: 'projectResource',
    redirect: '/project/resource/list',
    component: () => import('pages/micros/project/resource/McResource.vue'),
    meta: {
      title: 'Resources',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectResourceList',
        component: () => import('pages/micros/project/resource/ResourceList.vue'),
        meta: {
          title: 'Resources List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectResourceDetail',
        component: () => import('pages/micros/project/resource/ResourceDetail.vue'),
        meta: {
          title: 'Resource Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectResourceNew',
        component: () => import('pages/micros/project/resource/ResourceNew.vue'),
        meta: {
          title: 'New Resource',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/timesheet',
    name: 'projectTimesheet',
    redirect: '/project/timesheet/list',
    component: () => import('pages/micros/project/timesheet/McTimesheet.vue'),
    meta: {
      title: 'Timesheets',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectTimesheetList',
        component: () => import('pages/micros/project/timesheet/TimesheetList.vue'),
        meta: {
          title: 'Timesheets List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectTimesheetDetail',
        component: () => import('pages/micros/project/timesheet/TimesheetDetail.vue'),
        meta: {
          title: 'Timesheet Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectTimesheetNew',
        component: () => import('pages/micros/project/timesheet/TimesheetNew.vue'),
        meta: {
          title: 'New Timesheet',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/timesheet/approval',
    name: 'projectTimesheetApproval',
    redirect: '/project/timesheet/approval/list',
    component: () => import('pages/micros/project/timesheet/approval/TimesheetApproval.vue'),
    meta: {
      title: 'Timesheet Approvals',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectTimesheetApprovalList',
        component: () =>
          import('pages/micros/project/timesheet/approval/TimesheetApprovalList.vue'),
        meta: {
          title: 'Timesheet Approvals List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectTimesheetApprovalDetail',
        component: () =>
          import('pages/micros/project/timesheet/approval/TimesheetApprovalDetail.vue'),
        meta: {
          title: 'Timesheet Approval Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectTimesheetApprovalNew',
        component: () => import('pages/micros/project/timesheet/approval/TimesheetApprovalNew.vue'),
        meta: {
          title: 'New Timesheet Approval',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/setting',
    name: 'projectSetting',
    redirect: '/project/setting/list',
    component: () => import('pages/micros/project/setting/ProjectSetting.vue'),
    meta: {
      title: 'Settings',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectSettingList',
        component: () => import('pages/micros/project/setting/ProjectSettingList.vue'),
        meta: {
          title: 'Settings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectSettingDetail',
        component: () => import('pages/micros/project/setting/ProjectSettingDetail.vue'),
        meta: {
          title: 'Setting Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectSettingNew',
        component: () => import('pages/micros/project/setting/ProjectSettingNew.vue'),
        meta: {
          title: 'New Setting',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/project/todo',
    name: 'projectTodo',
    redirect: '/project/todo/list',
    component: () => import('pages/micros/project/todo/McTodo.vue'),
    meta: {
      title: 'Todos',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'projectTodoList',
        component: () => import('pages/micros/project/todo/TodoList.vue'),
        meta: {
          title: 'Todos List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'projectTodoDetail',
        component: () => import('pages/micros/project/todo/TodoDetail.vue'),
        meta: {
          title: 'Todo Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'projectTodoNew',
        component: () => import('pages/micros/project/todo/TodoNew.vue'),
        meta: {
          title: 'New Todo',
          requiresAuth: true,
        },
      },
      {
        path: 'resource',
        name: 'todoResource',
        redirect: 'resource/list',
        component: () => import('pages/micros/project/todo/resource/TodoResource.vue'),
        meta: {
          title: 'Todo-Resources',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'todoResourceList',
            component: () => import('pages/micros/project/todo/resource/TodoResourceList.vue'),
            meta: {
              title: 'Todo-Resources List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'todoResourceDetail',
            component: () => import('pages/micros/project/todo/resource/TodoResourceDetail.vue'),
            meta: {
              title: 'Todo-Resource Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'todoResourceNew',
            component: () => import('pages/micros/project/todo/resource/TodoResourceNew.vue'),
            meta: {
              title: 'New Todo-Resource',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
